import React from 'react';
import { connect } from 'react-redux';
import apiServiceUtils from '../utils/ApiServiceUtils';
import storeManager from '../../store/StoreManager';
import properties from '../../constants/Properties';
import mouseUtils from '../utils/MouseUtils';
import hoverManager from '../utils/HoverManager';
import { changeCartoonistTabIndex, changeContextMode } from '../../actions/MenuActions';
import modeType from '../../constants/ModeConstants';
import { SaveButton } from '../../components/menus/SaveButton';
import { changeAcoordionWidth } from '../../actions/AccordionActions';
import cartIcons from '../../styles/fonts/cartoonistIcons.css';
import audioEditorUtils from '../audioEditor/utils/AudioEditorUtils';
import masterUniverseUtils from '../utils/MasterUniverseUtils';
import locales from '../../locales/LocalesManager';

const Button = React.createClass({
    getInitialState () {
        return {
            isOver: false
        };
    },
    onMouseIn () {
        switch (this.props.index) {
            case 0: { // Text menu
                hoverManager.show(this.refs.button, 'mainMenuText', 'left');
                break;
            }
            case 1: { // Drawing
                hoverManager.show(this.refs.button, 'mainMenuDrawing', 'left');
                break;
            }
            case 2: { // Shapes
                hoverManager.show(this.refs.button, 'mainMenuShapes', 'left');
                break;
            }
            case 3: { // Frames
                hoverManager.show(this.refs.button, 'mainMenuFrames', 'left');
                break;
            }
            case 4: { // Effects
                hoverManager.show(this.refs.button, 'mainMenuEffects', 'left');
                break;
            }
            case 5: { // Media
                hoverManager.show(this.refs.button, 'mainMenuMedia', 'left');
                break;
            }
        }

        this.setState({
            isOver: true
        });
    },
    onMouseOut () {
        hoverManager.hide();

        this.setState({
            isOver: false
        });
    },
    onClick(e) {
        if (mouseUtils.rejectMouseEvent(e))
            return;

        const dispatch = storeManager.getStore().dispatch;

        switch (this.props.index) {
            case 0: { // Text
                dispatch(changeContextMode(modeType.TEXT));
                break;
            }
            case 1: { // Drawing
                dispatch(changeContextMode(modeType.FREEHAND));
                break;
            }
            case 2: { // Shapes
                dispatch(changeContextMode(modeType.SHAPES));
                break;
            }
            case 3: { // Frames
                dispatch(changeContextMode(modeType.FRAMES));
                dispatch(changeCartoonistTabIndex(4));
                break;
            }
            case 4: { // Effects
                dispatch(changeContextMode(modeType.EFFECTS));
                dispatch(changeCartoonistTabIndex(5));
                break;
            }
            case 5: { // Media
                dispatch(changeContextMode(modeType.MEDIA));
                var myMediaCategory = storeManager.getState().menu.myMediaCategory;

                if (myMediaCategory == undefined)
                    myMediaCategory = modeType.IMAGES;

                if (myMediaCategory == modeType.IMAGES)
                    dispatch(changeCartoonistTabIndex(7));
                else
                    dispatch(changeCartoonistTabIndex(8));
                break;
            }
        }

        if (this.props.accordionWidth == 0)
            dispatch(changeAcoordionWidth(properties.BROWSER_WIDTH));
    },
    isSelected() {
        const state = storeManager.getState();
        var contextMode = state.menu.contextMode;
        var isSelected = false;

        switch (this.props.index) {
            case 0: { // Text
                isSelected = contextMode == modeType.TEXT;
                break;
            }
            case 1: { // Drawing
                isSelected = contextMode == modeType.FREEHAND;
                break;
            }
            case 2: { // Shapes
                isSelected = contextMode == modeType.SHAPES;
                break;
            }
            case 3: { // Frames
                isSelected = contextMode == modeType.FRAMES;
                break;
            }
            case 4: { // Effects
                isSelected = contextMode == modeType.EFFECTS;
                break;
            }
            case 5: { // Media
                isSelected = contextMode == modeType.MEDIA;
                break;
            }
        }

        return isSelected;
    },
    render() {
        var tabHeight = 60;
        var iconTopPosition = 19;
        var src;
        var color;
        var iconColor;

        if (this.props.menuHeight < 370) {
            tabHeight = 36;
            iconTopPosition = 4;
        } else
        if (this.props.menuHeight < 420) {
            tabHeight = 40;
            iconTopPosition = 8;
        } else
        if (this.props.menuHeight < 485) {
            tabHeight = 50;
            iconTopPosition = 12;
        }

        var topPosition = tabHeight * this.props.index;

        if (this.isSelected()) {
            color = '#2377bb';
            iconColor = 'white';
        } else {
            color = 'white';

            if (this.state.isOver)
                iconColor = '#2377bb';
            else
                iconColor = 'black';
        }

        const tabStyle = {
            position: 'absolute',
            width: this.props.width,
            height: tabHeight,
            top: topPosition,
            userSelect: 'none',
            WebkitUserSelect: 'none',
            userDrag: 'none',
            cursor: 'pointer',
            background: color,
            borderStyle: 'none'
        };

        const iconStyle = {
            position: 'absolute',
            top: iconTopPosition,
            left: 7,
            fontSize: 23,
            color: iconColor
        };

        var ariaLabel = '';

        switch (this.props.index) {
            case 0: {
                src = 'cart-text-in-speechbubble';
                ariaLabel = locales.getCaption('mainMenuText', 'hover');
                break;
            }
            case 1: {
                src = 'cart-paint-brush';
                ariaLabel = locales.getCaption('mainMenuDrawing', 'hover');
                break;
            }
            case 2: {
                src = 'cart-shapes';
                ariaLabel = locales.getCaption('mainMenuShapes', 'hover');
                break;
            }
            case 3: {
                src = 'cart-frame';
                ariaLabel = locales.getCaption('mainMenuFrames', 'hover');
                break;
            }
            case 4: {
                src = 'cart-effect';
                ariaLabel = locales.getCaption('mainMenuEffects', 'hover');
                break;
            }
            case 5: {
                src = 'cart-folder';
                ariaLabel = locales.getCaption('mainMenuMedia', 'hover');
                break;
            }
        }

        return (
            <button ref='button' aria-label={ariaLabel} style={tabStyle} onMouseOver={this.onMouseIn} onMouseOut={this.onMouseOut} onClick={this.onClick} onTouchEnd={this.onClick}>
                <i style={iconStyle} className={cartIcons[src]}></i>
            </button>
        );
    }
});

const MainMenuContent = React.createClass({
    render() {
        var windowHeight = this.props.windowHeight - this.props.noInternetAlertHeight;
        var slideViewHeight = properties.SLIDE_VIEWER_TOP_LINE_HEIGHT + properties.SLIDE_VIEWER_TOP_GAP + properties.SLIDE_VIEWER_LIST_HEIGHT + properties.SLIDE_VIEWER_BOTTOM_GAP;

        if (this.props.showAudioEditor)
            slideViewHeight = slideViewHeight + audioEditorUtils.getAudioEditorHeight();

        var menuStyle = {
            position: 'absolute',
            top: apiServiceUtils.getNoInternetConnectionAlertHeight(),
            left: this.props.windowWidth - this.props.accordionWidth - properties.MAIN_MENU_WIDTH,
            width: properties.MAIN_MENU_WIDTH,
            height: windowHeight - slideViewHeight,
            backgroundColor: '#ffffff',
            userSelect: 'none',
            WebkitUserSelect: 'none',
            boxShadow: '2px 0px 8px'
        };

        var elementsStyle = {
            position: 'absolute',
            top: 125
        };

        if (menuStyle.height <= 330)
            elementsStyle.top = 110;

        var rightLineStyle = {
            position: 'absolute',
            top: 0,
            width: 1,
            height: menuStyle.height,
            left: menuStyle.width - 1,
            boxShadow: '0px 0px 10px'
        };

        if (this.props.contextMode == modeType.LINE_CONTEXT || this.props.contextMode == modeType.FREEHAND_CONTEXT || this.props.contextMode == modeType.ANIMATION_CONTEXT) {
            menuStyle.pointerEvents = 'none';
            menuStyle.opacity = 0.5;
        }

        return (
            <div style={menuStyle}>
                <SaveButton dispatch={this.props.dispatch} accordionWidth={this.props.accordionWidth} windowWidth={this.props.windowWidth} windowHeight={this.props.windowHeight}/>

                <div style={elementsStyle}>
                    <Button width={properties.MAIN_MENU_WIDTH} index={0} accordionWidth={this.props.accordionWidth} menuHeight={menuStyle.height}/>
                    <Button width={properties.MAIN_MENU_WIDTH} index={1} accordionWidth={this.props.accordionWidth} menuHeight={menuStyle.height}/>
                    <Button width={properties.MAIN_MENU_WIDTH} index={2} accordionWidth={this.props.accordionWidth} menuHeight={menuStyle.height}/>
                    <Button width={properties.MAIN_MENU_WIDTH} index={3} accordionWidth={this.props.accordionWidth} menuHeight={menuStyle.height}/>
                    <Button width={properties.MAIN_MENU_WIDTH} index={4} accordionWidth={this.props.accordionWidth} menuHeight={menuStyle.height}/>
                    <Button width={properties.MAIN_MENU_WIDTH} index={5} accordionWidth={this.props.accordionWidth} menuHeight={menuStyle.height}/>
                </div>

                <div style={rightLineStyle}></div>
            </div>
        );
    }
});

function mapStateToProps () {
    const state = storeManager.getState();
    const contextMode = state.menu.contextMode;
    var accordionWidth = state.accordion.width;
    var showAudioEditor = state.menu.showAudioEditor;
    var timelines = state.audioEditor.timelines;

    if (accordionWidth == undefined)
        accordionWidth = properties.BROWSER_WIDTH;

    return {
        contextMode,
        accordionWidth,
        showAudioEditor,
        timelines
    };
}

export const MainMenu = connect(mapStateToProps)(MainMenuContent);


/** WEBPACK FOOTER **
 ** ./src/components/menus/MainMenu.js
 **/